import { useModuleBEM } from "@b2bportal/core-themes";
import type { ParentState } from "@hopper-b2b/checkout";
import { useI18nContext } from "@hopper-b2b/i18n";
import clsx from "clsx";
import styles from "./styles.module.scss";

export type CheckoutStep = Extract<
  ParentState,
  | ParentState.contactInformation
  | ParentState.passengerInformation
  | ParentState.contactAndTravelerInformation
  | ParentState.seatSelection
  | ParentState.bagsSelection
  | ParentState.payment
  | ParentState.review
>;

export interface CheckoutStepData {
  state: CheckoutStep;
  label: string;
}

interface CheckoutStepHeaderProps {
  className?: string;
  steps: CheckoutStepData[];
  currentStep: CheckoutStep;
}

export const CheckoutStepHeader: React.FC<CheckoutStepHeaderProps> = ({
  steps,
  currentStep,
  className,
}) => {
  const { t } = useI18nContext();
  const [block, cn] = useModuleBEM(styles, "CheckoutStepHeader");
  const stepIdx = steps.findIndex((s) => s.state === currentStep);

  if (stepIdx < 0) {
    return null;
  }

  const progress = ((stepIdx + 1) / steps.length) * 100;

  return (
    <div className={clsx(block, className)}>
      <span className={cn("title")}>
        {`${t("checkoutSection.steps.stepProgressLabel", {
          currentStep: stepIdx + 1,
          totalSteps: steps.length,
        })} | ${steps[stepIdx].label}`}
      </span>
      <div className={cn("progress-bar")}>
        <div className={cn("progress")} style={{ width: `${progress}%` }} />
      </div>
    </div>
  );
};
